import { Box, useTheme } from '@mui/material'

import useIsPartner from '~/features/partners/hooks/useIsPartner/v2'
import EElement from '~/features/ui/models'
import CreateYourFreeLibbyButton from '~/layouts/chatbot/footer/createYourFreeLibbyButton'
import LogoAndFooterText from '~/layouts/chatbot/footer/logoAndFooterText'
import rem from '~/utils/ui'

function Footer() {
  const theme = useTheme()
  const isPartner = useIsPartner()

  return (
    <Box
      id={EElement.chatbotFooter}
      sx={{
        display: 'flex',
        justifyContent: isPartner ? 'flex-end' : 'space-between',
        alignItems: { xxxs: isPartner ? 'flex-end' : 'center', md: 'center' },
        flexDirection: { xxxs: 'row', xs: 'row' },
        gap: 2,
        backgroundColor: theme.palette.secondary1,
        paddingInline: rem(12),
        paddingBlock: rem(16),
        width: '100%',
        '& > *': {
          flex: isPartner ? '' : '1 1 50%',
        },
      }}
    >
      <LogoAndFooterText />
      {!isPartner && <CreateYourFreeLibbyButton />}
    </Box>
  )
}

export default Footer
